import type { RouteObject } from "react-router-dom";
import RootLayout from "@/components/layout/RootLayout";

import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Services from "@/pages/services/page";
import Projects from "@/pages/projects/page";
import Voucher from "@/pages/voucher/page";
import Recruit from "@/pages/recruit/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
    {
      children: [
        { path: "/portfolio", element: <Projects mode="portfolio" /> },
      ],
    },
    {
      element: <RootLayout />,
      children: [
          { path: "/", element: <Home /> },
          { path: "/about", element: <About /> },
          { path: "/services", element: <Services /> },
          { path: "/projects", element: <Projects mode="default" /> },
          { path: "/voucher", element: <Voucher /> },
          { path: "/recruit", element: <Recruit /> },
          { path: "/contact", element: <Contact /> },
          { path: "*", element: <NotFound /> },
      ],
    },
];

export default routes;
